import React, { Dispatch, SetStateAction, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { denyAlert } from "../../pages/alerts/alertsNeedingApproval/denyAlertSlice";
import { listApprovalAlert } from "../../pages/alerts/alertsNeedingApproval/listApprovalSlice";
import { checkAlertCount } from "../../pages/alerts/alertsNeedingApproval/utils";
import { approveAlert } from "../../pages/alerts/alertsNeedingApproval/approveAlertSlice";
import useNotification from "../notification/useNotification";
import { isSuccessResponse } from "../../common/utils";

const Modal4DenyAlert = ({
  alert,
  setDenyPop,
}: {
  alert?: any;
  setDenyPop?: Dispatch<SetStateAction<Boolean>>;
}) => {
  const dispatch: any = useDispatch();
  const [show, setShow] = useState<boolean>(true);
  const isAlertNotExpired: boolean = checkAlertCount(alert);
  const handleClose = () => {
    setDenyPop(false);
    setShow(false);
  };
  const { showSuccessNotification, showWarningNotification } = useNotification();
  const handleDeny = async () => {
    handleClose();
    const subscriptionIds: string[] = [alert._id];
    try {
      if (isAlertNotExpired) {
        await dispatch(denyAlert(subscriptionIds)).then((response) => {
          if (isSuccessResponse(response.payload)) {
            dispatch(listApprovalAlert());
            showSuccessNotification(response.payload.message);
          }
          else {
            showWarningNotification(response.payload.response.data.message);
          }
        });
      } else {
        await dispatch(approveAlert(subscriptionIds)).then((response) => {
          if (isSuccessResponse(response.payload)) {
            dispatch(listApprovalAlert());
            showSuccessNotification(response.payload.message);
          }
          else {
            showWarningNotification(response.payload.response.data.message);
          }
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setDenyPop(false);
    setShow(false);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        className="modal-container modalDenyalerts"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="delete-heading">
              <h1>{isAlertNotExpired ? `Deny Alert` : `Alert is Expired`}</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {isAlertNotExpired
              ? `Are you sure you want to deny the alert?`
              : `This alert is expired`}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-delete" onClick={handleDeny}>
            ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Modal4DenyAlert;
